import { getCachedClientConfig, receiptToEmpresaCupom } from "@caixa/lib/clientConfig";

function resolveApiBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_API_BASE_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  return "/api";
}

export const config = {
  /** URL base da API do sistema de gestão */
  BASE_URL: resolveApiBaseUrl(),

  /** Enviar cookies (sessão PHP) */
  credentials: "include" as RequestCredentials,

  /** Dados da empresa para cupom — da config do cliente (api/.env) */
  get empresa() {
    return receiptToEmpresaCupom(getCachedClientConfig().receipt);
  },
};
